import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { eDiloService } from '../../services/eDilo';


interface Limit {
	limit: string;
	used: string;
}

const formatNumber = (value: number): string => {
	return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const LimitWidget = () => {
		const { account } = useSelector((state: RootState) => state.account);
		const [limits, setLimits] = useState<Limit>({ limit: '0.00', used: '0.00' });
		const [isLoading, setIsLoading] = useState(false);

		useEffect(() => {
			if (!account) return;
			fetchLimits(account);
			const interval = setInterval(() => fetchLimits(account), 2 * 60 * 1000);
			return () => clearInterval(interval);
		}, [account]);

		const fetchLimits = (account: string) => {
			eDiloService.getCurrentLimit(account)
				.then(({ Result }) => {
					const { Доступно, Использовано } = Result;

					setLimits({
						limit: formatNumber(Доступно),
						used: formatNumber(Использовано),
					});
				})
				.catch((err) => console.log(err))
				.finally(() => setIsLoading(false));
		};

		return (
			<Tooltip title="Придбайте талони з відтермінуванням оплати до 90 днів.
Графік оплати та історію переказів можна переглянути в кабінеті eDilo.">
				<div className="flex align-items-center limit-widget">
					<div className="flex vertical align-items-center">
						<span className="title">Паливний ліміт</span>
						<span className="limit green">{isLoading ? '...' : `${limits.limit}₴`}</span>
					</div>
					<div className="flex vertical align-items-center">
						<span className="title">Використано</span>
						<span className="limit red">{isLoading ? '...' : `${limits.used}₴`}</span>
					</div>
					<Button href="https://web.edilo.com.ua" target={'_blank'} type="primary"
					        style={{ backgroundColor: '#323434', color: '#A9F9F3' }}>eDilo</Button>
				</div>
			</Tooltip>
		);
	}
;

